const App = {
  namespaced: true,

  state: {
    drawer: false,

  },
  mutations:{
    setDrawer(state, payload){
      state.drawer = payload;
    }
  },
  actions : {
    setDrawer(ctx, payload){
      ctx.commit('setDrawer', payload);
    }
  },


  getters: {
    getDrawer: state => state.drawer
  }
};

export default App;